// routes
import { PATH_DASHBOARD } from './routes/paths';

// SEO / сниппеты ссылок (Telegram, Slack и т.д.). Переопределяется при сборке через REACT_APP_META_* в .env
// ----------------------------------------------------------------------

const META_TITLE_DEFAULT = 'Commerce workspace';
const META_DESCRIPTION_DEFAULT =
  'Orders, inventory, marketplaces, and fulfillment in one operations workspace. Sign in to run your commerce from a single hub.';

export const APP_META = {
  /** Заголовок вкладки и og:title по умолчанию */
  title: process.env.REACT_APP_META_TITLE || META_TITLE_DEFAULT,
  /** meta description + og:description */
  description: process.env.REACT_APP_META_DESCRIPTION || META_DESCRIPTION_DEFAULT,
  /** Короткое имя продукта (суффикс «| …» в title, og:site_name) */
  siteName: process.env.REACT_APP_META_SITE_NAME || process.env.REACT_APP_META_TITLE || META_TITLE_DEFAULT,
  /** Абсолютный URL сайта для canonical, og:url и og:image (без слэша в конце не обязательно) */
  canonicalUrl: (process.env.REACT_APP_META_CANONICAL_URL || '').replace(/\/$/, ''),
} as const;

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAP_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
